<template>
  <v-form ref="inventoriesFilterForm">
    <base-material-filter
      title="Търсене на инвентаризации"
      :hasFilters="hasActiveFilters"
      v-on:do-filter="doFilter"
      v-on:remove-filter="clearFilters" 
    >
      <v-row @keypress.enter="doFilter" class="mx-1">
        <v-col md="4" offset-md="2">
          <v-text-field 
            label="Наименование"
            v-model="filters.name"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2">
          <base-material-date-picker 
            v-model="filters.date"
            label="Дата"
          />
        </v-col>
        <v-col md="1">
          <base-select
            :items="properties.finished"
            item-text="name"
            item-value="value"
            v-model="filters.isFinished"
            label="Приключена"
            clearable
            autocomplete="off"
          >
          </base-select>
        </v-col>
      </v-row>
    </base-material-filter>
  </v-form>
</template>

<script>

import { isEmptyObject } from "@/utils";

const filtersModel = Object.freeze({
  name: '',
  date: '',
  isFinished: ''
})

export default {
  name: "inventoriesFilter",
  props: {
    postOnClearData: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      properties: {
        finished: [
          {
            name: 'Да',
            value: 1
          },
          {
            name: 'Не',
            value: 0
          }
        ]
      },
      rules: {},
      filters: Object.assign({}, filtersModel),
      hasActiveFilters: false
    }
  },
  mounted(){},
  methods: {
    doFilter(){
      if(this.$refs.inventoriesFilterForm.validate()){
        if(!isEmptyObject(this.filters) || (isEmptyObject(this.filters) && this.filters.isClosedAccount === null)){
          this.filters.page = 1;
          this.hasActiveFilters = true;
          this.$emit("doFilter");
          delete this.filters.page;
        } else {
          if(this.hasActiveFilters === true)
            this.$emit("doFilter");
            
          this.hasActiveFilters = false;
        }
      }
    },
    clearFilters(){
      this.filters = Object.assign({}, filtersModel)

      this.hasActiveFilters = false;

      this.$emit("doFilter", this.postOnClearData);
    },
  }
}
</script>